import React from 'react';

import { Facepile } from '@xingternal/facepile';

import SocialProofText from './SocialProofText';

import { BodyCopy } from '@xingternal/typography';
import type * as Types from '@xingternal/pages-graphql-types';
import { SocialProofUsersType } from '../types';

import styles from './SocialProof.css';

type SocialProofDataType = {
  users?: SocialProofUsersType[];
  total: number;
  proofType?: Types.EntityPageSocialProofType | null;
};
type SocialProofProps = {
  pageId: string;
  socialProofData?: SocialProofDataType;
};

const usersForSocialProof = (users: SocialProofUsersType[]) => {
  const usersForSocialProof = users.slice(0, 3);

  return usersForSocialProof.map((user) => {
    user.id = user.id;
    return user;
  });
};

const SocialProof = ({ socialProofData, pageId }: SocialProofProps) => (
  <>
    {socialProofData && (
      <section className={styles.socialProofWrapper}>
        <div className={styles.imagesWrapper}>
          <Facepile
            className={styles.socialProofImages}
            actors={socialProofData.users ? usersForSocialProof(socialProofData.users) : []}
            maxActors={3}
            size="small"
            sizeWide="medium"
          />
        </div>
        <BodyCopy size={'small'} className={styles.contactsWrapper}>
          {socialProofData.users && socialProofData.proofType && <SocialProofText
            pageId={pageId}
            users={socialProofData.users}
            total={socialProofData.total}
            proofType={socialProofData.proofType}
          />}
        </BodyCopy>
      </section>
    )}
  </>
);

export default SocialProof;
